module.exports = __webpack_public_path__ + "img/Mask Group 2921@2x.a746e7fc.png";